
import { Component, Vue } from 'vue-property-decorator'
import SellerHeader from '@/components/Seller/SellerHeader.vue'
import { UserService } from '@/services/user.service'

@Component({
  components: {
    SellerHeader,
  },
})
export default class AdministrationMenu extends Vue {
  jwt = localStorage.getItem('access_token')
  businessAdmin = false

  async mounted() {
    const user = UserService.getCurrentUser() || await UserService.getUserData()
    this.businessAdmin = user ? UserService.isBusinessAdmin(user) : false
  }

  goToCreateEvent() {
    const jwt = localStorage.getItem('access_token')
    window.location.href =
      process.env.VUE_APP_ADMIN_DOMAIN + '/events/create' + '?jwt=' + jwt
  }

  goToBulkImport() {
    const jwt = localStorage.getItem('access_token');
    window.location.href = process.env.VUE_APP_ADMIN_DOMAIN + '/seller/administration/seller-bulk-import' + '?jwt=' + jwt;
  }

  v2Birthday(route: string): void {
    const jwt = localStorage.getItem('access_token')
    window.location.href =
     process.env.VUE_APP_REPORTS_APP_URL + route + '?jwt=' + jwt
  }
}
